import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      "& .MuiPaper-root": {
        minWidth: 600,
        boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
        borderRadius: 16
      }
    },
    dialogTitle: {
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
      padding: "1.6rem 2.4rem",
      background:
        "linear-gradient(90deg, #007E92 0%, #009FB8 50.13%, #00B9A3 100%)",
      "& .MuiTypography-root": {
        color: "#FFFFFF",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }
    },
    flexCenter: {
      display: "flex",
      alignItems: "center"
    },
    icon: {
      marginRight: "2.1rem",
      "& path": {
        stroke: "#FFFFFF"
      }
    },
    closeIcon: {
      cursor: "pointer",
      "& path": {
        stroke: "#FFFFFF"
      }
    },
    noteGps: {
      background: "#EEEEEE",
      border: "1px dashed #999999",
      borderRadius: 4,
      padding: "0.8rem 1.6rem"
    },
    table: {
      marginTop: "0.8rem",
      width: "100%",
      border: "1px solid #E0E0E0",
      borderRadius: 4,
      "& .MuiTableBody-root": {
        "& .MuiTableCell-root": {
          height: 36,
          padding: "0.9rem 1.6rem",
          verticalAlign: "text-top"
        }
      },
      "& .MuiTableHead-root": {
        "& .MuiTableCell-root": {
          height: 36,
          padding: "0.9rem 1.6rem"
        }
      }
    },
    cellPrimary: {
      maxWidth: 160,
      width: 160,
      minWidth: 160,
      "& .MuiTypography-root": {
        color: theme.palette.info.dark
      }
    },
    boxContent: {
      padding: "2.4rem !important",
      overflowY: "auto"
    }
  }),
  {
    name: "ModalGpsTracking"
  }
);

export default useStyles;
